/* eslint-disable array-callback-return */
import { ColumnGroupType, ColumnType } from 'antd/lib/table';
import { Input, Select, Table } from 'components';
import { FormikProvider, useFormik, FormikProps } from 'formik';
import { dayjs } from 'libs';
import { chunk, findIndex, uniqBy, uniqueId } from 'lodash';
import React, { FC, useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { workerService } from 'services';
import * as Types from 'types';
import { GetPerformanceItemResponse } from 'types';
import { TableProps } from 'antd';
import { useParams } from 'react-router-dom';
import { siteDetailSelector } from '../selectors';
import { getPerformanceWorkArea } from '../thunk';
import { TableFormStyle } from './styles';

interface Props {
  currentDay?: Date | string;
}

type DtFormTable = {
  value_1: string;
  value_2: string;
  unit: string;
};

type DataTable = {
  id: string;
  lengthWork?: number;
  name?: string;
  work_content?: string;
  charge_1?: DtFormTable;
  charge_2?: DtFormTable;
  charge_3?: DtFormTable;
  charge_4?: DtFormTable;
  charge_5?: DtFormTable;
  work_detail_list?: {
    performance_value: number;
    performance_unit: string;
    work_area: number;
    work_detail_content_id: number;
  }[];
};
type ListSelectProps = { name: string; value: number | string; work_master_id: number }[];
const PerformanceWorkAreaContext = React.createContext<
  Types.GetPerformanceWorkAreaResponse[] | null
>(null);
sessionStorage.setItem('listSelect', JSON.stringify([]));
const DataTableContext = React.createContext<{ name: string; value: number | string }[]>([]);
const ListSelect = React.createContext<ListSelectProps>([]);

export const TableForm: FC<Props> = ({ currentDay }) => {
  const { Performance, PerformanceWorkArea } = useSelector(siteDetailSelector);
  const { site_id, buildingId } = useParams<{ site_id: string; buildingId: string }>();
  const dispatch = useDispatch();
  const checkDiff = useMemo(() => {
    if (currentDay) {
      return dayjs(currentDay).diff(dayjs(new Date()).format('YYYY-MM-DD'), 'day') <= -14;
    }
    return false;
  }, [currentDay]);
  const [listSelect, setListSelect] = useState<ListSelectProps>([]);

  const initData = useMemo(() => {
    let result: ListSelectProps = [];
    if (
      !!Performance?.data?.cooperator_work_list.length &&
      Performance?.data?.cooperator_work_list.length > 0
    ) {
      Performance.data.cooperator_work_list.map((itemCooperatorWorkList) => {
        if (!!(itemCooperatorWorkList?.work_list.length > 0)) {
          itemCooperatorWorkList.work_list.map((itemWorkList) => {
            if (
              itemWorkList &&
              itemWorkList?.work_detail_list &&
              itemWorkList?.work_detail_list.length > 0
            ) {
              itemWorkList?.work_detail_list.map((itemWorkListData, index) => {
                result.push({
                  work_master_id: itemWorkList.work_master_id,
                  name: `select_work_${itemWorkList.work_master_id}_id-${index}`,
                  value: itemWorkListData.work_area,
                });
              });
            }
          });
        }
      });
      return result;
    }
    return uniqBy(result, 'name');
  }, [Performance.data]);

  useEffect(() => {
    if (initData) {
      setListSelect(initData);
      sessionStorage.setItem('listSelect', JSON.stringify(initData));
    }
  }, [initData]);
  const dataTable = useMemo(() => {
    let data: DataTable[] = [];
    //convert data
    Performance.data &&
      Performance.data.cooperator_work_list.map((user) => {
        let newWorkList: GetPerformanceItemResponse[] = [];
        if (!!(user.work_list.length > 0)) {
          user.work_list.map((workDetail) => {
            if (!!(workDetail.work_detail_list.length > 5)) {
              chunk(workDetail.work_detail_list, 5).map((item, indexItem) => {
                if (!!(item.length > 0)) {
                  newWorkList.push({
                    ...workDetail,
                    construction_content: indexItem === 0 ? workDetail.construction_content : '',
                    work_detail_list: item,
                  });
                }
              });
            } else {
              newWorkList.push(workDetail);
            }
          });
        }
        if (!!(newWorkList.length > 0)) {
          newWorkList.map((item, index) => {
            if (index === 0) {
              data.push({ ...item, name: user.user_name, id: `${index}` });
            } else {
              data.push({ ...item, id: `${index}` });
            }
          });
        }
        return data;
      });

    let fixedData: DataTable[] = [];

    data.map((d) => {
      if (d.work_detail_list && d.work_detail_list.length > 5) {
        const chunkSize = 5;
        for (let i = 0; i < d.work_detail_list.length; i += chunkSize) {
          const chunk = d.work_detail_list.slice(i, i + chunkSize);
          fixedData.push({
            ...d,
            work_detail_list: chunk,
          });
        }
      } else {
        fixedData.push({ ...d, name: d?.name });
      }
    });
    return fixedData;
  }, [Performance.data]);
  const formik = useFormik({
    initialValues: {},
    onSubmit: (values) => {
      console.log(values);
    },
  });

  const columnConvert = useMemo(() => {
    let data: ColumnGroupType<TableProps<DataTable>> | ColumnType<TableProps<DataTable>>[] = [
      {
        title: '作業員名',
        dataIndex: 'name',
        width: '10%',
        render: (value: string) => {
          return value;
        },
      },
      {
        title: '作業内容',
        dataIndex: 'construction_content',
        className: 'boder-left table-margin',
        width: '13%',
        render: (value: string) => {
          return <div>{value}</div>;
        },
      },
    ];
    const numberColumn: number[] = [];
    if (Performance.data) {
      Performance.data?.cooperator_work_list.map((item) => {
        if (item && item.work_list && item.work_list.length > 0) {
          item.work_list.map((itemWorkList) => {
            if (itemWorkList.work_detail_list && itemWorkList.work_detail_list.length > 0) {
              numberColumn.push(itemWorkList.work_detail_list.length);
            }
          });
        }
      });
    }
    if (Math.max(...numberColumn) > 0) {
      for (let index = 0; index < 5; index++) {
        data.push({
          title: `担当箇所${index + 1}`,
          width: '20%',
          className: 'boder-left',
          render: (value: Types.GetPerformanceItemResponse) => {
            if (!value?.work_detail_list[index] || !value?.work_detail_list[index]?.work_area) {
              return '-';
            }
            return (
              <FormTable
                formik={formik}
                callBack={(v) => {
                  const getListSelect =
                    sessionStorage.getItem('listSelect') &&
                    JSON.parse(sessionStorage.getItem('listSelect') ?? `[]`);
                  let indexFind = findIndex(getListSelect, { name: v.name });
                  if (indexFind !== -1) {
                    let arrClone = getListSelect;
                    arrClone.splice(indexFind, 1, v);
                    setListSelect(arrClone);
                    sessionStorage.setItem('listSelect', JSON.stringify([...arrClone]));
                    return;
                  }
                  sessionStorage.setItem('listSelect', JSON.stringify([...listSelect, v]));
                  setListSelect([...listSelect, v]);
                }}
                branch_no={value.branch_no}
                work_master_id={value?.work_master_id}
                indexItem={index}
                disabled={checkDiff}
                value={value}
                name={`work_${value?.work_master_id}_id-${index}`}
              />
            );
          },
        });
      }
    }

    return data;
  }, [checkDiff, listSelect, Performance.data, formik]);

  const fetchWorkAreaWithBranchNo = useCallback(() => {
    const listBranchNo: string[] = [];
    Performance.data &&
      Performance.data.cooperator_work_list.map((user) => {
        if (!!user.work_list.length) {
          user.work_list.map((workDetail) => {
            if (!listBranchNo.includes(workDetail.branch_no)) {
              listBranchNo.push(workDetail.branch_no);
            }
          });
        }
      });
    listBranchNo.map((branch_no) => {
      const params = buildingId
        ? { branch_no, building_id: buildingId }
        : site_id
        ? { branch_no, site_id }
        : {};

      dispatch(getPerformanceWorkArea(params));
    });
  }, [Performance.data, buildingId, dispatch, site_id]);
  useEffect(() => {
    fetchWorkAreaWithBranchNo();
  }, [fetchWorkAreaWithBranchNo]);

  return (
    <PerformanceWorkAreaContext.Provider value={PerformanceWorkArea.data}>
      <ListSelect.Provider value={listSelect}>
        <DataTableContext.Provider value={[]}>
          <FormikProvider value={formik}>
            <TableFormStyle>
              <Table<TableProps<DataTable>>
                columns={columnConvert}
                dataSource={dataTable}
                loading={Performance.loading}
                rowKey={({ id }) => `${id}${uniqueId()}`}
              />
            </TableFormStyle>
          </FormikProvider>
        </DataTableContext.Provider>
      </ListSelect.Provider>
    </PerformanceWorkAreaContext.Provider>
  );
};

interface PropsFormTable {
  value?: Types.GetPerformanceItemResponse;
  disabled?: boolean;
  name?: string;
  branch_no?: string;
  work_master_id: number;
  indexItem: number;
  formik: FormikProps<{}>;
  callBack?: (e: { name: string; value: number | string; work_master_id: number }) => void;
}

const FormTable: FC<PropsFormTable> = ({
  value,
  name = '',
  disabled = false,
  work_master_id,
  indexItem,
  branch_no,
}) => {
  const PerformanceWorkArea = useContext(PerformanceWorkAreaContext);
  // const dataList = useContext(ListSelect);
  const dataList =
    sessionStorage.getItem('listSelect') &&
    JSON.parse(sessionStorage.getItem('listSelect') ?? `[]`);
  const [valueSelect, setValueSelect] = useState<number | string | undefined>(
    value && value?.work_detail_list[indexItem]?.work_area
  );
  const [warning, setWarning] = useState<'warning' | ''>('');
  const [valueInput, setValueInput] = useState<number | string | undefined>(
    value && value?.work_detail_list[indexItem]?.work_area
  );
  const checkDuplicateValueWorkArea = useCallback(
    ({
      data,
      work_master_id,
      value,
    }: {
      data: {
        name: string;
        value: string | number;
        work_master_id: number;
      }[];
      value?: number | string;
      work_master_id: number;
      indexItem: number;
    }) => {
      let result = false;
      if (!data) {
        return '';
      }

      const listSelect = data
        .filter((item) => item.name !== `select_${name}` && item.work_master_id === work_master_id)
        .map((item) => item.value);
      if (listSelect && listSelect.length > 0 && !!value && listSelect.includes(value)) {
        return true;
      }
      if (listSelect && listSelect.length > 0 && !value) {
        const currentItem = data.find((item) => item.name === `select_${name}`);
        if (currentItem && listSelect.includes(`${currentItem.value}`)) {
          return true;
        }
      }
      return result;
    },
    [name]
  );

  const actionUpdate = async (data: Types.PostPerformanceRequest) => {
    try {
      workerService.postPerformanceUpdate(data);
    } catch (error) {}
  };
  let callApiUpdateInput = useRef<NodeJS.Timeout>();
  useEffect(() => {
    if (
      dataList &&
      indexItem &&
      work_master_id &&
      checkDuplicateValueWorkArea({
        data: dataList,
        work_master_id,
        indexItem,
      })
    ) {
      setWarning('warning');
    }
  }, [checkDuplicateValueWorkArea, dataList, indexItem, work_master_id]);
  const dataSelect = useMemo(() => {
    const data: { value: string; label: string }[] = [];
    if (!PerformanceWorkArea) {
      return data;
    }
    const findList = PerformanceWorkArea.find((item) => item.branch_no === branch_no);
    findList?.work_area_list.map((item) => {
      data.push({
        value: item?.work_area?.toString(),
        label: item?.work_area?.toString() === '0' ? '屋外' : item?.work_area,
      });
    });

    return data;
  }, [PerformanceWorkArea, branch_no]);
  return (
    <div className="box-form">
      <Select
        className={`select_${name} ${warning} work_detail_content_id-${value?.work_detail_list?.[indexItem]?.work_detail_content_id}`}
        defaultValue={value?.work_detail_list[indexItem]?.work_area?.toString()}
        disabled={disabled}
        placeholder={'担当箇所'}
        onChange={(e) => {
          if (disabled) {
            return;
          }
          setValueSelect(e);

          value?.work_detail_list[indexItem]?.work_detail_content_id &&
            actionUpdate({
              work_detail_content_id: value?.work_detail_list[indexItem]?.work_detail_content_id,
              work_area: e,
              performance_value:
                valueInput || value?.work_detail_list[indexItem]?.performance_value,
            });
          const getListSelect: ListSelectProps =
            sessionStorage.getItem('listSelect') &&
            JSON.parse(sessionStorage.getItem('listSelect') ?? `[]`);
          let indexFind = findIndex([...getListSelect], { name: `select_${name}` });
          let newDataSet;
          if (indexFind !== -1) {
            let arrClone = getListSelect;
            arrClone.splice(indexFind, 1, { name: `select_${name}`, value: e, work_master_id });
            arrClone[indexFind] = { name: `select_${name}`, value: +e, work_master_id };
            newDataSet = [...arrClone];
          } else {
            newDataSet = [...getListSelect, { name: `select_${name}`, value: e, work_master_id }];
          }
          sessionStorage.setItem('listSelect', JSON.stringify(newDataSet));
          if (
            checkDuplicateValueWorkArea({
              data: newDataSet,
              work_master_id,
              value: e,
              indexItem,
            })
          ) {
            setWarning('warning');
          } else {
            setWarning('');
          }
        }}
        options={dataSelect}
      />

      <Input
        disabled={disabled}
        defaultValue={value?.work_detail_list[indexItem]?.performance_value}
        className={`input input-${name} work_detail_content_id-${value?.work_detail_list?.[indexItem]?.work_detail_content_id}`}
        onChange={(e) => {
          if (!e.target.value || disabled) {
            return;
          }
          if (callApiUpdateInput.current) {
            clearTimeout(callApiUpdateInput.current);
          }

          setValueInput(e.target.value?.toString());
          callApiUpdateInput.current = setTimeout(() => {
            value?.work_detail_list[indexItem]?.work_detail_content_id &&
              actionUpdate({
                work_detail_content_id: value?.work_detail_list[indexItem]?.work_detail_content_id,
                work_area: valueSelect || value?.work_detail_list[indexItem]?.work_area,
                performance_value: e.target.value,
              });
          }, 500);
        }}
        name={`input-${name}`}
      />
      <div className="box-unit">
        <span>{value?.work_detail_list[indexItem]?.performance_unit}</span>
      </div>
    </div>
  );
};
